import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';

const selectRoot = ({ timespans }: RootState) => timespans;

export const selectTimespans = createSelector(
    selectRoot,
    ({ timespans }) => timespans,
);
